namespace Controlli {
    export namespace Bar {
        export function Render(options: ChartOptions) {
            ChartsGlobal.RenderChart(options.DivIdValue, InitParams(options))
        }

        function InitParams(initOptions: ChartOptions): Object {
            let plotHeight = (initOptions.ChartHeight == null || initOptions.ChartHeight == 0 ? 500 : initOptions.ChartHeight);
            let columnW = (initOptions.PlotSize == null || initOptions.PlotSize == 0 ? "80%" : initOptions.PlotSize + "%");
            let showLegend = false;
            let showDataLabels = false;
            let showAxisY = false;
            let chartPosition = 'back';

            initOptions.Series.Series.forEach((valore) => {
                valore.color = Controlli.Utility.GetChartColor(valore.color);
            })
            
            let result = {
                series: initOptions.Series.Series,
                chart: {
                    id: initOptions.ChartId,
                    height: plotHeight,
                    type: initOptions.Type,
                    toolbar: {
                        show: true,
                        tools: {
                            download: false,
                            selection: false,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: false,
                            reset: '<i class="fa-duotone fa-rotate-left fa-xl"></i>',
                            customIcons: []
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: columnW,
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: showDataLabels,
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                grid: {
                    show: true,
                    borderColor: '#ff0066',
                    strokeDashArray: 5,
                    position: chartPosition,
                    xaxis: {
                        lines: {
                            show: true
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: showLegend,
                },
                xaxis: {
                    categories: initOptions.Series.Categories,
                },
                yaxis: {
                    show: showAxisY,
                    max: initOptions.MaxStepsValue,
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            const numberFormatter = new Intl.NumberFormat('it-IT', {
                                style: 'decimal',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            const formattedNumber = numberFormatter.format(val);

                            return formattedNumber;
                        }
                    },
                    fixed: {
                        enabled: true,
                        position: 'topLeft',
                        offsetX: 0,
                        offsetY: 0,
                    },
                }
            };
            return result;
        }

        //Contain the parameters for setting up the donut chart
        export class ChartOptions extends ChartsGlobal.BaseChart {
            CategoriesAxisX: Set<string>;
            MaxStepsValue: number;
            Series: ChartsData;
        }

        class ChartsData {
            Categories: Array<string>;
            Series: Array<ChartSerie>
        }

        class ChartSerie {
            name: string
            data: object[]
            color: string
            type: string
        }

    }
}